module.exports = __webpack_public_path__ + "static/media/QC_Logo.733b777c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/QC_Logo.png
// module id = 119
// module chunks = 0